export function normalizeOptionalEventCapacity(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const capacity = Number(value);
  return Number.isFinite(capacity) ? capacity : null;
}
